<!-- Schichtanteile -->
<div class="schicht-section" *ngIf="cachedSchichten.length > 0" [class.veg-clickable]="canEdit" (click)="openVegetation()">
	<div class="schicht-header">Schichtanteile</div>
	<div class="schicht-summaries">
		<div *ngFor="let sch of cachedSchichten" class="schicht-summary">
			<span class="schicht-label">{{schichtLabel(sch)}}</span>
			<span class="schicht-value">{{bp.bodenvegetation.aufnahme.schichtAnteile[sch] ?? '–'}}</span>
		</div>
	</div>
</div>

<!-- Vegetationstabelle -->
<style>
tr.group-even, tr.group-odd { border: none !important; }
tr.group-even td, tr.group-odd td { border: none !important; }
tr.group-even:first-of-type, tr.group-odd:not(.group-even) + tr.group-even { border-top: 1px solid #dee2e6 !important; }
tr.group-even + tr.group-odd { border-top: 1px solid #dee2e6 !important; }
</style>
<table class="table table-sm no-bottom-margin tborder lborder rborder bborder" [class.veg-clickable]="canEdit" [ngClass]="{ 'bp-print-view': printView}">
	<tbody>
		<tr (click)="openVegetation()">
			<th>Schicht</th>
			<th class="w-75">Vegetation</th>
			<th class="text-right">%</th>
		</tr>
		<tr *ngFor="let row of cachedVegetationen" [class.group-even]="row.groupEven" [class.group-odd]="!row.groupEven" (click)="openVegetation()">
			<td class="schicht-cell"><span class="cell-text">{{row.rowspan > 0 && row.schicht ? schichtLabel(row.schicht) : ''}}</span></td>
			<td class="w-75"><span class="cell-text">{{row.vegetation}}</span></td>
			<td class="text-right"><span class="cell-text">{{row.haeufigkeit}}</span></td>
		</tr>
		<tr *ngIf="cachedVegetationen.length === 0" (click)="openVegetation()">
			<td colspan="3"><span class="cell-text"><i class="bi bi-plus"></i></span></td>
		</tr>
	</tbody>
</table>

<div style="height: 0.75rem;"></div>

<!-- Humusform / Bestand / Bemerkungen -->
<!-- Humusform, Vegetationsformengruppe und Bestand sind forstliche Bewertungen und
     stehen nur bei einer Aufnahme nach SEA 95. Die Kartieranleitung hat ihre eigene
     Humusform in der Profilkennzeichnung (Feld 63); zwei davon in einem Punkt waeren
     eine Falle. Die Bemerkungen bleiben in jedem Verfahren. -->
<style>.veg-dark-hover tr:hover td, .veg-dark-hover tr:hover th { background-color: #2a5a4a !important; cursor: pointer; }</style>
<table *ngIf="!printView" class="table table-sm table-dark no-bottom-margin veg-dark-hover" [class.veg-clickable]="canEdit" [ngClass]="{ 'bp-print-view': printView}">
	<tbody>
		@if (istSeaPunkt) {
			<tr class="tborder lborder rborder" (click)="openVegetation()">
				@if (hatHumusForm(bp) || hatVegetationsformengruppe(bp)) {
					<th>{{humusformLabel(bp)}}</th>
					<td><span class="cell-text">{{humusformDisplay()}}</span></td>
				}
			</tr>
			<tr class="lborder rborder" (click)="openVegetation()">
				<th>Bestand</th>
				<td><span class="cell-text">{{baumarten()}}</span></td>
			</tr>
		}
		<!-- Mehrzeilen-Feld wie im Reiter „Boden": Nackter Text in der Zelle verlor die
		     getippten Zeilenumbrueche (Nutzer-Befund 24.09.2026). -->
		<tr class="lborder rborder bborder" [class.tborder]="!istSeaPunkt" (click)="openVegetation()">
			<th>Bemerkungen</th>
			<td><wd-multiline-text name="Bemerkungen" [model]="bp.header.bemerkungen"></wd-multiline-text></td>
		</tr>
	</tbody>
</table>
